import { CustomValidators } from 'shared/validation/custom-validators';
import * as _ from 'lodash';

import { countryLookup, } from 'utils/lookups';
import { defaultOptionValue } from 'shared/form/select/option-helpers';
import {
  expirationDateValidation, cardNumberValidation,
} from 'shared/validation/card-validation';


/* eslint-disable */
export const billingData: any = [
  {
    "field_map": "email",
    "item_name": "email",
    "title": "Email address",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        maxLength: 254,
        validator: CustomValidators.email,
        message: 'Email must be provided',
      },
    },
  },
  {
    "field_map": "address1",
    "item_name": "address1",
    "title": "Billing address 1",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'Billing address 1 must be provided',
      },
    },
  },
  {
    "field_map": "address2",
    "item_name": "address2",
    "title": "Billing address 2",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "country",
    "item_name": "country",
    "title": "Country",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": _.filter(countryLookup, (country) => {
      return (_.indexOf(['US', 'MX', 'CA'], country.option) > -1);
    }),
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'Country must be provided'
      },
    },
  },
  {
    "field_map": "city",
    "item_name": "city",
    "title": "City",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'City must be provided'
      },
    },
  },
  {
    "field_map": "state",
    "item_name": "state",
    "title": "State",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        validator: CustomValidators.notEqual(defaultOptionValue),
        message: 'State must be provided'
      },
    },
  },
  {
    "field_map": "zipCode",
    "item_name": "zip_code",
    "title": "ZIP",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'Zip code must be provided'
      },
    },
  },
  {
    "field_map": "creditCard",
    "item_name": "credit_card",
    "title": "Card number",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        custom: cardNumberValidation,
      },
    },
  },
  {
    "field_map": "cvv",
    "item_name": "cvv",
    "title": "CVV",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'CVV must be provided'
      },
    },
  },
  {
    "field_map": "expDate",
    "item_name": "exp_date",
    "title": "Expiration",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "validation": {
      'BILLING_VALIDATION': {
        custom: expirationDateValidation,
      },
    },
  },
  {
    "field_map": "cardholderName",
    "item_name": "cardholder_name",
    "title": "Cardholder name",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'BILLING_VALIDATION': {
        required: true,
        message: 'Cardholder name must be provided'
      },
    },
  },
];
/* eslint-enable */
